import { Box, Button, Tooltip } from '@mantine/core';
import { IconFileTypePdf } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useAppNotification } from '@feature/utils';

import { useTravelRequestDownloadTravelOrder } from '../model/TravelRequestQuery';
import { TravelRequest } from '../model/TravelRequestTypes';

interface TravelRequestTravelOrderButtonProps {
  request: TravelRequest;
}

export function TravelRequestTravelOrderButton({ request }: TravelRequestTravelOrderButtonProps) {
  const { t } = useTranslation();
  const notification = useAppNotification();
  const download = useTravelRequestDownloadTravelOrder(request.id);
  const { available, fileName } = request.travelOrder;

  // A disabled button emits no mouse events, so the tooltip hangs off a wrapper instead.
  return (
    <Tooltip
      label={t(
        request.status === 'CANCELLED'
          ? 'travel.requests.view.travelOrderCancelled'
          : 'travel.requests.view.travelOrderUnavailable',
      )}
      disabled={available}
      events={{ hover: true, focus: true, touch: true }}
      multiline
      w={280}
    >
      <Box
        component="span"
        display="inline-block"
        data-disabled={!available || undefined}
      >
        <Button
          size="xs"
          variant="outline"
          leftSection={<IconFileTypePdf size={14} />}
          disabled={!available}
          loading={download.isPending}
          onClick={() => download.mutate(fileName ?? 'Ordin-deplasare.pdf', { onError: notification.error })}
        >
          {t('travel.requests.view.downloadTravelOrder')}
        </Button>
      </Box>
    </Tooltip>
  );
}
